import { Component, Input, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { ModalCancelarGrupoService } from './modal-cancelar-grupo.service';
import { NotificationsService } from 'angular2-notifications';
import { Router } from '@angular/router';

@Component({
  selector: 'ngx-modal-cancelar-grupo',
  templateUrl: './modal-cancelar-grupo.component.html',
  styleUrls: ['./modal-cancelar-grupo.component.scss']
})
export class ModalCancelarGrupoComponent implements OnInit {

  @Input() nomeGrupo: string;
  @Input() id: any;
  @Input() grupo: string;
  @Input() frm: any;

  public spinnerLoad: boolean = false;
  public customLogin = null;
  public titleGrupo = 'Inativar Grupo';
  public descricaoGrupo = 'Todos os usuários associados a esse grupo irão perder as permissões de acesso ao portal!';
  public subDescGrupo = 'Deseja realmente inativar o grupo';

  public ativaGrupo = 'Ativar grupo geral';
  public desativaGrupo = 'Desativar grupo geral';
  public ativarPermissao = 'Todos os usuários associados a esse grupo irão ganhar permissões de acesso ao portal!';
  public desativarPermissao = 'Todos os usuários associados a esse grupo irão perder permissões de acesso ao portal!'

  public title = null;
  public descricao = null;
  public subDescricao = null;
  public grupoId = null;

  constructor(
    private service: ModalCancelarGrupoService,
    private notifications: NotificationsService,
    protected ref: NbDialogRef<ModalCancelarGrupoComponent>,
    private router: Router,
  ) { }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);

    if (this.grupo === "Grupo") {
      this.title = this.titleGrupo;
      this.descricao = this.descricaoGrupo;
      this.subDescricao = this.subDescGrupo;
      this.grupoId = this.id;
    } else if (this.grupo === 'S') {
      this.title = this.ativaGrupo;
      this.descricao = this.ativarPermissao;
      this.grupoId = this.id;
    } else {
      this.title = this.desativaGrupo;
      this.descricao = this.desativarPermissao;
      this.grupoId = [];
    }

  }

  saveGrupoMenuTree() {

    this.spinnerLoad = true;

    let dataPersist = {
      perfil: {
        id: this.frm.id,
        descricao: this.frm.descricao,
        produtoId: this.frm.produtoId,
        status: this.frm.status
      },
      roleAcessoIds: this.grupoId.map(function (grupoMenu) {
        return grupoMenu.id
      })
    }

    this.service.saveMenusGrupo(
      dataPersist,
      () => {
        if (this.grupo == 'S') {
          this.notifications.success('Grupo salvo com sucesso!');
        } else {
          this.notifications.success('Grupo desativado com sucesso!');
        }
        this.ref.close();
        if (this.grupo === 'Grupo') {
          this.router.navigate(['/pages/gestao-user-terceiro/lista-admin-grupo']);
        }
        this.spinnerLoad = false;
      }, (error) => {
        this.spinnerLoad = false;
        this.notifications.error(error.message)
      })
  }

  closeModal() {
    this.ref.close();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }

}